"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var delimiter = {
  decimal: '.',
  thousand: ','
};
var addDelimiter = function addDelimiter(fixedString, thousandDelimiter) {
  var _fixedString$split = fixedString.split(delimiter.decimal),
    _fixedString$split2 = _slicedToArray(_fixedString$split, 2),
    dollars = _fixedString$split2[0],
    cents = _fixedString$split2[1];
  var formattedDollars = new Intl.NumberFormat('en-AU', {
    useGrouping: true
  }).format(Number(dollars));
  var localeDelimiter = ',';
  var finalDollars = thousandDelimiter === localeDelimiter ? formattedDollars : formattedDollars.replace(new RegExp(localeDelimiter, 'g'), thousandDelimiter);
  return cents ? "".concat(finalDollars).concat(delimiter.decimal).concat(cents) : finalDollars;
};
var formatCurrency = function formatCurrency(amount) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if ((0, _fp.isNil)(amount) || !(0, _fp.isFinite)(amount)) {
    return null;
  }
  var _options$minimumFract = options.minimumFractionDigits,
    minimumFractionDigits = _options$minimumFract === void 0 ? 2 : _options$minimumFract,
    _options$includeDolla = options.includeDollarSign,
    includeDollarSign = _options$includeDolla === void 0 ? true : _options$includeDolla,
    _options$thousandsDel = options.thousandsDelimiter,
    thousandsDelimiter = _options$thousandsDel === void 0 ? delimiter.thousand : _options$thousandsDel;
  var formattedValue = addDelimiter(amount.toFixed(minimumFractionDigits), thousandsDelimiter);
  return "".concat(includeDollarSign ? '$' : '').concat(formattedValue);
};
var _default = exports["default"] = formatCurrency;
module.exports = exports.default;